import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { KIND_META } from '../qualityConfig';
import { itemKey } from './CatalogPicker';

export const SelectedTray = ({ items, onRemove, onClear }) => (
    <div className="border-t bg-muted/30 px-4 py-3" data-testid="assign-selected-tray">
        <div className="mb-2 flex items-center justify-between">
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground" data-testid="assign-selected-count">Selected · {items.length}</p>
            {items.length > 0 && (
                <button type="button" onClick={onClear} className="text-xs text-muted-foreground hover:text-foreground" data-testid="assign-clear-selection">Clear all</button>
            )}
        </div>
        {items.length === 0 ? (
            <p className="text-xs text-muted-foreground">Pick simulations from any of the tabs above — you can mix modules in one task.</p>
        ) : (
            <div className="flex max-h-24 flex-wrap gap-1.5 overflow-y-auto">
                <AnimatePresence initial={false}>
                    {items.map((it) => {
                        const meta = KIND_META[it.kind];
                        const Icon = meta.icon;
                        return (
                            <motion.span
                                key={itemKey(it)}
                                layout
                                initial={{ scale: 0.85, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.85, opacity: 0 }}
                                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${meta.tone}`}
                                data-testid={`assign-selected-chip-${it.kind}-${it.ref_key}`}
                            >
                                <Icon className="h-3 w-3" />
                                <span className="max-w-[180px] truncate">{it.title}</span>
                                <button type="button" onClick={() => onRemove(it)} aria-label={`Remove ${it.title}`} className="rounded-full p-0.5 hover:bg-black/10">
                                    <X className="h-3 w-3" />
                                </button>
                            </motion.span>
                        );
                    })}
                </AnimatePresence>
            </div>
        )}
    </div>
);
